import React, { useState } from 'react'

const Image = (props) => {
  let { className, src, fallback=null } = props;
  const [error, setError] = useState(false)
  const [load, setLoad] = useState(false)
  const onErrorHandler = (event) => setError(true)
  const onLoadHandler = (event) => setLoad(true)
  if (!load){
    className += ' hidden'
  } else {
    className += ' fade-in delay slow'
  }
  if (!src){
    return fallback 
  }
  if (error){
    return fallback
  } else {
    return (
      <img src={src} 
           onError={onErrorHandler} 
           onLoad={onLoadHandler} 
           className={className}
      />)
  }
}

export default Image
